import { createContext } from 'react'

// AI-CONTEXT: See docs/features/deep-analysis-period.md

/**
 * @typedef {object} PeriodRange
 * @property {string|null} start - ISO date 'YYYY-MM-DD' or null (unbounded)
 * @property {string|null} end - ISO date 'YYYY-MM-DD' or null (unbounded)
 */

/**
 * @typedef {object} DeepAnalysisPeriod
 * @property {import('../helpers/compareHelpers/periodQuery').CardPeriodValue|null} periodValue - The chosen period + compare setting, read from the url (null = all data)
 * @property {PeriodRange|null} rangeA - Primary period (null = all data)
 * @property {PeriodRange|null} rangeB - Compare period (null when not comparing)
 * @property {boolean} compareActive - Show two periods side by side
 * @property {(value: import('../helpers/compareHelpers/periodQuery').CardPeriodValue|null) => void} setPeriodValue - Writes a new period to the url
 */

/**
 * The period the deep-analysis page is showing. DeepAnalysisPage owns it (from
 * the url query) and every section reads it here, however deep it sits.
 * Default null: outside the deep-analysis page every section shows all data,
 * exactly as before.
 * @type {React.Context<DeepAnalysisPeriod|null>}
 */
const DeepAnalysisPeriodContext = createContext(null)

export default DeepAnalysisPeriodContext
